import React, {Component} from 'react';
import { Delete } from '@material-ui/icons';
import grey from '@material-ui/core/colors/grey';
import { withStyles } from '@material-ui/core/styles';
import { TableCell } from '@material-ui/core';
import ConfirmButton from './ConfirmButton';

/**
 * Icon button component used on PaginedList 
 * to remove user, invitation or domain item
 */

const styles = theme => ({
  tools: {
    textAlign: "right"
  },
  iconButton: {
    color: grey[600],
  },
})

class ListDeleteButton extends Component {
  
  render() {
    const {classes, handleRemove, title, message, working} = this.props;
    return (
      <TableCell className={classes.tools}>
        <ConfirmButton
          iconButton
          color="primary"
          size="small"
          onClick={handleRemove}
          title={title}
          message={message}
          working={working}
        >
          <Delete className={classes.iconButton} />
        </ConfirmButton>
      </TableCell>
    )
  }
}

export default withStyles(styles)(ListDeleteButton);


// WEBPACK FOOTER //
// ./src/components/ListDeleteButton.js